// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
/* Axios avec Vue-axios */
import VueAxios from 'vue-axios'
import axios from 'axios'
/* Bootstrap-vue */
import BootstrapVue from 'bootstrap-vue'
/* SCSS */
import '../src/sass/app.scss'

// Import Bootstrap in Vuejs
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// configuration de axios et VueAxios
axios.interceptors.request.use(function (config) {
  config.baseURL = process.env.API_URL

  return config
}, function (error) {
  return Promise.reject(error)
})

Vue.use(VueAxios, axios)

Vue.config.productionTip = false

Vue.use(BootstrapVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js